export class PatientInteractionLocationEligibilityPeriod {
  id: number;
  startDate: Date | string;
  terminationDate: Date | string;
}
